/* bootstrap-spin - v3.0.2 - https://www.npmjs.com/package/bootstrap-input-spinner */
!(function (t) {
  "use strict";
  var e = function (t, e) {
      var n = t.locale || "en-US";
      (this.parse = function (t) {
        var e = new Intl.NumberFormat(n),
          r = e.format(11111).replace(/1/g, "") || ".",
          o = e.format(1.1).replace(/1/g, "");
        return parseFloat(
          t
            .replace(new RegExp(" ", "g"), "")
            .replace(new RegExp("\\" + r, "g"), "")
            .replace(new RegExp("\\" + o), ".")
        );
      }),
        (this.render = function (t) {
          var r = parseInt(e.getAttribute("data-decimals")) || 0,
            o = !("false" === e.getAttribute("data-digit-grouping"));
          return new Intl.NumberFormat(n, {
            minimumFractionDigits: r,
            maximumFractionDigits: r,
            useGrouping: o,
          }).format(t);
        });
    },
    n = !1,
    r = t.fn.val;
  function o(t, e) {
    t.addEventListener("mousedown", function (t) {
      0 === t.button && (t.preventDefault(), e(t));
    }),
      t.addEventListener("touchstart", function (t) {
        t.cancelable && t.preventDefault(), e(t);
      }),
      t.addEventListener("keydown", function (t) {
        (32 !== t.keyCode && 13 !== t.keyCode) || n || ((n = !0), e(t));
      });
  }
  (t.fn.val = function (t) {
    if (arguments.length >= 1)
      for (var e = 0; e < this.length; e++)
        this[e]["bootstrap-input-spinner"] &&
          this[e].setValue &&
          this[e].setValue(t);
    return r.apply(this, arguments);
  }),
    (t.fn.inputSpinner = function (r) {
      if ("destroy" === r)
        return (
          this.each(function () {
            this["bootstrap-input-spinner"]
              ? this.destroyInputSpinner()
              : console.warn("element", this, "is no bootstrap-input-spinner");
          }),
          this
        );
      var i = {
        decrementButton: "<strong>&minus;</strong>",
        incrementButton: "<strong>&plus;</strong>",
        groupClass: "",
        buttonsClass: "btn-outline-secondary",
        buttonsWidth: "2.5rem",
        textAlign: "center",
        autoDelay: 500,
        autoInterval: 50,
        buttonsOnly: !1,
        keyboardStepping: !0,
        locale: navigator.language,
        editor: e,
        template:
          '<div class="input-group ${groupClass}"><button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button><input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/><button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div>',
      };
      for (var a in r) i[a] = r[a];
      var p = i.template
        .replace(/\${groupClass}/g, i.groupClass)
        .replace(/\${buttonsWidth}/g, i.buttonsWidth)
        .replace(/\${buttonsClass}/g, i.buttonsClass)
        .replace(/\${decrementButton}/g, i.decrementButton)
        .replace(/\${incrementButton}/g, i.incrementButton)
        .replace(/\${textAlign}/g, i.textAlign);
      return (
        this.each(function () {
          if (this["bootstrap-input-spinner"])
            console.warn(
              "element",
              this,
              "is already a bootstrap-input-spinner"
            );
          else {
            var e = t(this);
            (e[0]["bootstrap-input-spinner"] = !0),
              e.hide(),
              (e[0].inputSpinnerEditor = new i.editor(i, this));
            var r = null,
              a = null,
              u = t(p),
              s = u.find(".btn-decrement"),
              l = u.find(".btn-increment"),
              d = u.find("input"),
              c = t("label[for='" + e.attr("id") + "']");
            c[0] || (c = e.closest("label"));
            var f = null,
              m = null,
              b = null;
            B();
            var v = parseFloat(e[0].value),
              g = e.attr("data-prefix") || "",
              h = e.attr("data-suffix") || "";
            if (g) {
              var y = t('<span class="input-group-text">' + g + "</span>");
              u.find("input").before(y);
            }
            if (h) {
              var w = t('<span class="input-group-text">' + h + "</span>");
              u.find("input").after(w);
            }
            (e[0].setValue = function (t) {
              $(t);
            }),
              (e[0].destroyInputSpinner = function () {
                e.prop("required", d.prop("required")),
                  x.disconnect(),
                  S(),
                  d.off("paste input change focusout"),
                  u.remove(),
                  e.show(),
                  (e[0]["bootstrap-input-spinner"] = void 0),
                  c[0] && c.attr("for", e.attr("id"));
              });
            var x = new MutationObserver(function () {
              B(), $(v, !0);
            });
            x.observe(e[0], { attributes: !0 }),
              e.after(u),
              $(v),
              d
                .on("paste input change focusout", function (t) {
                  var n = d[0].value,
                    r = "focusout" === t.type;
                  $((n = e[0].inputSpinnerEditor.parse(n)), r), N(e, t.type);
                })
                .on("keydown", function (t) {
                  i.keyboardStepping &&
                    (38 === t.which
                      ? (t.preventDefault(), s.prop("disabled") || k(b))
                      : 40 === t.which &&
                        (t.preventDefault(), l.prop("disabled") || k(-b)));
                })
                .on("keyup", function (t) {
                  !i.keyboardStepping ||
                    (38 !== t.which && 40 !== t.which) ||
                    (t.preventDefault(), S());
                }),
              o(s[0], function () {
                s.prop("disabled") || k(-b);
              }),
              o(l[0], function () {
                l.prop("disabled") || k(b);
              }),
              (E = document.body),
              (C = function () {
                S();
              }),
              E.addEventListener("mouseup", function (t) {
                C(t);
              }),
              E.addEventListener("touchend", function (t) {
                C(t);
              }),
              E.addEventListener("keyup", function (t) {
                (32 !== t.keyCode && 13 !== t.keyCode) || ((n = !1), C(t));
              });
          }
          var E, C;
          function $(t, n) {
            void 0 === n && (n = !0),
              isNaN(t) || "" === t
                ? ((e[0].value = ""), n && (d[0].value = ""), (v = NaN))
                : ((t = parseFloat(t)),
                  (t = Math.min(Math.max(t, f), m)),
                  (e[0].value = t),
                  n && (d[0].value = e[0].inputSpinnerEditor.render(t)),
                  (v = t));
          }
          function N(t, e) {
            e &&
              setTimeout(function () {
                var n;
                "function" == typeof Event
                  ? (n = new Event(e, { bubbles: !0 }))
                  : (n = document.createEvent("Event")).initEvent(e, !0, !0),
                  t[0].dispatchEvent(n);
              });
          }
          function k(t) {
            F(t),
              S(),
              (r = setTimeout(function () {
                a = setInterval(function () {
                  F(t);
                }, i.autoInterval);
              }, i.autoDelay));
          }
          function F(t) {
            isNaN(v) && (v = 0),
              $(Math.round(v / t) * t + t),
              N(e, "input"),
              N(e, "change");
          }
          function S() {
            clearTimeout(r), clearTimeout(a);
          }
          function B() {
            e.prop("required") &&
              (d.prop("required", e.prop("required")),
              e.removeAttr("required")),
              d.prop("placeholder", e.prop("placeholder")),
              d.attr("inputmode", e.attr("inputmode") || "decimal");
            var t = e.prop("disabled"),
              n = e.prop("readonly");
            d.prop("disabled", t),
              d.prop("readonly", n || i.buttonsOnly),
              l.prop("disabled", t || n),
              s.prop("disabled", t || n),
              (t || n) && S();
            var r = e.prop("class"),
              o = "";
            /form-control-sm/g.test(r)
              ? (o = "input-group-sm")
              : /form-control-lg/g.test(r) && (o = "input-group-lg");
            var a = r.replace(/form-control(-(sm|lg))?/g, "");
            u.prop("class", "input-group " + o + " " + i.groupClass),
              d.prop("class", "form-control " + a),
              (f =
                isNaN(e.prop("min")) || "" === e.prop("min")
                  ? -1 / 0
                  : parseFloat(e.prop("min"))),
              (m =
                isNaN(e.prop("max")) || "" === e.prop("max")
                  ? 1 / 0
                  : parseFloat(e.prop("max"))),
              (b = parseFloat(e.prop("step")) || 1),
              e.attr("hidden")
                ? u.attr("hidden", e.attr("hidden"))
                : u.removeAttr("hidden"),
              e.attr("id") &&
                (d.attr("id", e.attr("id") + "_MP_cBdLN29i2"),
                c[0] && c.attr("for", d.attr("id")));
          }
        }),
        this
      );
    });
})(jQuery);

!(function (Helpers, $, undefined) {
  "use strict";

  var truncateText = function (target, limit, affix) {
    if (!limit) var limit = 250;
    if (!affix) var affix = "...";

    jQuery(target).each(function () {
      var content = jQuery(this).html();
      if (content.length > limit) {
        var c = content.substr(0, limit);
        var h = content;
        var html =
          '<div class="truncate-text" style="display:block">' +
          c +
          '<span class="moreellipses">' +
          affix +
          '</span>&nbsp;&nbsp;<a href="" class="moreless more">read more</a>' +
          "</div>" +
          '<div class="truncate-text" style="display:none">' +
          h +
          '<a href="" class="moreless less">read less</a></div>';

        jQuery(this).html(html);
      }
    });

    jQuery(".moreless").click(function () {
      var thisEl = jQuery(this);
      var cT = thisEl.closest(".truncate-text");
      var tX = ".truncate-text";

      if (thisEl.hasClass("less")) {
        cT.prev(tX).toggle();
        cT.slideToggle();
      } else {
        cT.toggle();
        cT.next(tX).fadeToggle();
      }
      return false;
    });
  };

  var bindUIActions = function () {
    jQuery(".modal.fade").appendTo("body");

    if (jQuery(".truncate").length > 0) {
      truncateText(
        jQuery(".truncate"),
        jQuery(".truncate").data("truncate-limit")
      );
    }

    if (parseInt(jQuery(window).width()) > 1200) {
      jQuery(".navbar-nav.tier-1 > .dropdown").hover(
        function () {
          jQuery(".navbar-nav.tier-1 .dropdown").removeClass("open");
          jQuery(this).addClass("open");
          jQuery("main").prepend('<div class="mainNavOverlay"></div>');
        },
        function () {
          jQuery(this).removeClass("open");
          jQuery("div.mainNavOverlay").not(".cart").remove();
        }
      );
    } else {
      let menu = jQuery(".navbar-nav.tier-1");

      jQuery(".navbar-toggler").on("click", function (evt) {
        menu.removeClass("open");
        menu.find(".dropdown.open").removeClass("open");
      });

      jQuery(".navbar-nav.tier-1 > .dropdown > .dropdown-toggle").on(
        "click",
        function (evt) {
          evt.preventDefault();
          if (parseInt(menu.css("left")) == 0) {
            jQuery(this).parent().toggleClass("open");
            menu.addClass("open");
          }
        }
      );

      jQuery("#navbar-tier-2 > .dropdown").on("click", function () {
        jQuery(this).siblings().removeClass("open");
        jQuery(this).toggleClass("open");
      });

      jQuery("a.menu-back").on("click", function () {
        menu.removeClass("open");
        menu.find(".dropdown.open").removeClass("open");
        jQuery(this).parent().parent().focusout();
      });
    } // if( parseInt(jQuery(window).width()) > 768 )

    if (jQuery(".block-carousel .carousel-container").length > 0) {
      jQuery(".block-carousel .carousel-container")
        .not(".slick-initialized")
        .slick({
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          touchMove: true,
        });
    } // if( jQuery('.block-carousel').length > 0 )

    if (jQuery(".block-content-carousel .carousel-container").length > 0) {
      jQuery(".block-content-carousel .carousel-container")
        .not(".slick-initialized")
        .slick({
          arrows: true,
          slidesToShow: 1,
          touchMove: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: true,
              },
            },
          ],
        });
    } // if( jQuery('.block-content-carousel .carousel-container').length > 0 )

    if (
      jQuery(".top-banner").length > 0 &&
      parseInt(jQuery(window).width()) < 768
    ) {
      jQuery(".top-banner .d-flex").not(".slick-initialized").slick({
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        touchMove: true,
      });
    } // if( jQuery('.block-content-carousel .carousel-container').length > 0 )

    if (jQuery(".block-logos .logo-carousel").length > 0) {
      jQuery(".block-logos .logo-carousel").slick({
        arrows: true,
        slidesToShow: 4,
        touchMove: true,
        responsive: [
          {
            breakpoint: 1028,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    } // if( jQuery('.product-carousel').length > 0 )

    if (jQuery(".product-carousel").length > 0) {
      var slide_count = jQuery(".product-carousel .product-grid").data("items");
      jQuery(".product-carousel .product-grid")
        .not(".slick-initialized")
        .slick({
          arrows: true,
          slidesToShow: slide_count,
          slidesToScroll: 1,
          infinite: true,
          touchMove: true,
          responsive: [
            {
              breakpoint: 968,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                dots: true,
              },
            },
            {
              breakpoint: 468,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                centerMode: true,
                centerPadding: "10%",
              },
            },
          ],
        });
    } // if( jQuery('.product-carousel').length > 0 )
  };

  Helpers.init = function () {
    bindUIActions();

    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    if (parseInt(jQuery(window).width()) < 768) {
      var toastElList = [].slice.call(document.querySelectorAll(".toast"));
      var toastList = toastElList.map(function (toastEl) {
        return new bootstrap.Toast(toastEl, { delay: 7000 });
      });
    }
  };
})((window.Helpers = window.Helpers || {}), jQuery),
  (function (HomePage, $, undefined) {
    "use strict";

    HomePage.init = function () {
      if (jQuery(".block-collection").length > 0) {
        jQuery(".block-collection .product-grid")
          .not(".slick-initialized")
          .slick({
            arrows: true,
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 3,
                  touchMove: true,
                },
              },
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 2,
                  touchMove: true,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  touchMove: true,
                },
              },
            ],
          });
      }
    };
  })((window.HomePage = window.HomePage || {}), jQuery),
  (function (Blog, $, undefined) {
    var bindUIActions = function () {};

    Blog.init = function () {
      bindUIActions();
    };
  })((window.Blog = window.Blog || {}), jQuery),
  (function (Page, $, undefined) {
    var bindUIActions = function () {
      window.addEventListener("load", function () {
        var tab_ele = document.querySelector(location.hash + "-tab");
        var offset = -30;
        if (tab_ele) {
          var position =
            tab_ele.getBoundingClientRect().top + window.pageYOffset + offset;
          var tab = new bootstrap.Tab(tab_ele);
          tab.show();
          window.scrollTo({ top: position, behavior: "smooth" });
        }
      });
      jQuery(".filter-publications").on("change", function () {
        if (jQuery(this).val()) {
          jQuery(".publications .item").hide();
          jQuery(".publications .item." + jQuery(this).val()).show();
        } else {
          jQuery(".publications .item").show();
        }
      });
    };

    Page.init = function () {
      bindUIActions();
    };
  })((window.Page = window.Page || {}), jQuery),
  (function (Collections, $, undefined) {
    var bindUIActions = function () {
      jQuery(".product-filters :radio").on("change", function () {
        var current_tags = jQuery(".product-filters").data("current-tags");
        var tag_arr = current_tags.split("+");
        var selected_group = jQuery(this).attr("name");
        var new_tag = "";

        jQuery(tag_arr).each(function (i) {
          var handlize_tag = tag_arr[i]
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/-$/, "")
            .replace(/^-/, "");
          if (!handlize_tag.includes(selected_group)) {
            new_tag += handlize_tag + "+";
          }
        });

        new_tag += jQuery(this).attr("value");

        var url =
          jQuery(".product-filters").data("collection-url") +
          "/" +
          new_tag +
          "#products";
        window.location.href = url;
      });

      jQuery(".product-filters button.clear-filter-group").on(
        "click",
        function () {
          var current_tags = jQuery(".product-filters").data("current-tags");
          var tag_arr = current_tags.split("+");
          var selected_group = jQuery(this).data("filter-group");
          var new_tag = "";

          jQuery(tag_arr).each(function (i) {
            var handlize_tag = tag_arr[i]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "");
            if (!handlize_tag.includes(selected_group)) {
              new_tag += handlize_tag + "+";
            }
          });

          var url =
            jQuery(".product-filters").data("collection-url") +
            "/" +
            new_tag +
            "#products";
          window.location.href = url;
        }
      );

      // If carousel content exists
      if (jQuery(".product-card .image-carousel").length > 0) {
        jQuery(".product-card .image-carousel")
          .not(".slick-initialized")
          .slick({
            touchMove: true,
            lazyLoad: "ondemand",
            arrows: true,
          });
      }
    };

    Collections.init = function () {
      bindUIActions();
    };
  })((window.Collections = window.Collections || {}), jQuery),
  (function (ProductPage, $, undefined) {
    ProductPage.product = false;
    ProductPage.variants = false;
    ProductPage.current_variant = false;

    var changeVariant = function () {
      var variant = ProductPage.current_variant;

      jQuery("[variant-select] option").attr("selected", false);
      jQuery('[variant-select] option[value="' + variant.id + '"]').attr(
        "selected",
        true
      );

      // update UI items
      updatePrice(); // Updates display price and sale display
      updateImage();
      updateCTA(variant.available); // Display Buy CTA for Variant
    };

    var updatePrice = function () {
      var productPrice = ProductPage.current_variant.price;
      var originalPrice = ProductPage.current_variant.compare_at_price;

      // set proper format and update price UI
      jQuery(".product-header [product-price]").html(
        Shopify.formatMoney(productPrice)
      );

      // If variant is on sale, update sale pricing UI
      if (productPrice < originalPrice) {
        jQuery(".product-header [original-price]").html(
          Shopify.formatMoney(originalPrice)
        );
        jQuery(".product-header [original-price], .badge-sale").removeClass(
          "d-none"
        );
      } else {
        jQuery(".product-header [original-price], .badge-sale").addClass(
          "d-none"
        );
      }
    };

    var updateCTA = function (is_available) {
      var variant = ProductPage.current_variant;

      if (is_available == true) {
        jQuery(".btn-buy").attr("id", "AddToCart-Primary");
        if (
          variant.inventory_quantity < 1 &&
          variant.inventory_policy == "continue"
        ) {
          jQuery(".btn-buy span").html(
            "Pre-Order"
          );
          jQuery(".floating-buy-bar button span").html(
            "Pre-Order"
          );
        } else {
          jQuery(".btn-buy span").html(
            "Add to Bag"
          );
          jQuery(".floating-buy-bar button span").html(
            "Add to Bag"
          );
        }
      } else {
        jQuery(".btn-buy").attr("id", "BIS_trigger");
        jQuery(".btn-buy span").html("Email me when available");
      }
    };

    var updateImage = function () {
      var variant_id = ProductPage.current_variant.id;
      var variant_image = ProductPage.current_variant.featured_image;

      if (
        jQuery("#mip-carousel .carousel-hero").length >= 1 &&
        ProductPage.current_variant.featured_image != null
      ) {
        initMip();
        jQuery("#mip-carousel div .carousel-hero").slick(
          "slickGoTo",
          ProductPage.current_variant.featured_image.position - 1,
          true
        );
      }
    };

    var initMip = function () {
      var carousel_element = "#mip-carousel div .carousel-hero";
      var carousel_nav_element = "#mip-carousel div .carousel-nav";
      // If carousel content exists
      if (jQuery(carousel_element).length > 0) {
        jQuery(carousel_element).not(".slick-initialized").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          touchMove: true,
          arrows: true,
          fade: true,
          dots: true,
          lazyLoad: "ondemand",
          asNavFor: carousel_nav_element,
          nextArrow:
            '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289L6.34315 0.928932C5.95262 0.538408 5.31946 0.538408 4.92893 0.928932C4.53841 1.31946 4.53841 1.95262 4.92893 2.34315L10.5858 8L4.92893 13.6569C4.53841 14.0474 4.53841 14.6805 4.92893 15.0711C5.31946 15.4616 5.95262 15.4616 6.34315 15.0711L12.7071 8.70711ZM0 9L12 9V7L0 7L0 9Z" fill="#1e1e1e"/></svg></button>',
          prevArrow:
            '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289L6.34315 0.928932C5.95262 0.538408 5.31946 0.538408 4.92893 0.928932C4.53841 1.31946 4.53841 1.95262 4.92893 2.34315L10.5858 8L4.92893 13.6569C4.53841 14.0474 4.53841 14.6805 4.92893 15.0711C5.31946 15.4616 5.95262 15.4616 6.34315 15.0711L12.7071 8.70711ZM0 9L12 9V7L0 7L0 9Z" fill="#1e1e1e"/></svg></button>',
        });

        jQuery(carousel_nav_element).not(".slick-initialized").slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          touchMove: true,
          focusOnSelect: true,
          infinite: true,
          arrows: false,
          vertical: true,
          asNavFor: carousel_element,
        });

        jQuery(carousel_nav_element)
          .find(".slick-slide")
          .each(function (index) {
            jQuery(this).css(
              "margin-top",
              (jQuery(carousel_nav_element).height() - jQuery(this).height()) /
                2 +
                "px"
            );
          });
      } // end If carousel content exists
    };

    var updateHistoryState = function () {
      // Update history state for product deeplinking
      var hash = "?";
      if (window.location.search.length > 2) {
        hash = window.location.search.split("variant")[0];
        if (!hash.endsWith("&") && hash.length > 2) hash += "&";
      } else {
        hash = window.location.hash.split("variant")[0];
        if (!hash.endsWith("&") && hash.length > 2) hash += "&";
        hash =
          hash.split("?")[0] +
          "?" +
          (hash.split("?")[1] ? hash.split("?")[1] : "");
      }
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        hash +
        "variant=" +
        ProductPage.current_variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    };

    var getCurrentVariant = function (variantId) {
      var variants = ProductPage.product.variants;
      // map variants and return the selected one

      var found = jQuery.map(variants, function (variant) {
        if (variant.id == variantId) {
          return variant; // return matching variant object
        }
      });

      return found[0]; // returns single array so pull out first element object
    };

    var activateTab = function () {
      var target = jQuery(window.location.hash.split("?")[0]);
      if (target.length > 0) {
        target.toggle();
        return true;
      }
      return false;
    };

    var showBuyBar = function () {
      var y = window.scrollY;
      var header_height = jQuery(".product-header").height() - 200;
      if (y >= header_height) {
        jQuery(".floating-buy-bar").fadeIn();
      } else {
        jQuery(".floating-buy-bar").fadeOut();
      }
    };

    var bindUIActions = function () {
      jQuery("#product_buy_actions [quantity-select]").inputSpinner();

      if (jQuery(".block-featured-in").length > 0) {
        var slide_count = jQuery(".block-featured-in .d-flex").data("items");
        jQuery(".block-featured-in .d-flex").slick({
          slidesToShow: slide_count,
          slidesToScroll: slide_count,
          touchMove: true,
          arrows: true,
          dots: true,
          responsive: [
            {
              breakpoint: 968,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
              },
            },
            {
              breakpoint: 468,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
              },
            },
          ],
        });
      } // if( jQuery('.product-carousel').length > 0 )

      jQuery("[variant-list] button").click(function () {
        ProductPage.current_variant = getCurrentVariant(
          jQuery(this).data("variant-id")
        );

        jQuery(".variant-select h6").css("color", "");
        jQuery("[variant-list] .btn").removeClass("active");
        jQuery(this).addClass("active");

        changeVariant();
        updateHistoryState();
      });

      jQuery(".scroll").click(function () {
        var ele = jQuery(this).attr("href");
        ele = jQuery(ele).find(".collapse");
        jQuery(ele).collapse("show");
      });

      var rebuildRecharge = setInterval(function () {
        if (jQuery(".rc_container_wrapper").length > 0) {
          jQuery(".rc_widget__option__label").each(function (index) {
            jQuery(this).find(".rc_widget__price").prependTo(this);
            var discount_elem = jQuery(this).find(
              ".rc_widget__option__discount"
            );
            if (discount_elem.html() != undefined) {
              discount_elem.html(
                " (Free Gifts + " +
                  discount_elem.html() +
                  " OFF + Free Shipping)"
              );
            }
          });

          var default_interval = jQuery("[data-recharge-interval]").data(
            "recharge-interval"
          );
          jQuery(
            '.rc_widget__option__plans__dropdown option[value="' +
              default_interval +
              '"]'
          ).append(" (recommended)");
          jQuery(".rc_widget__option__plans__dropdown").val(default_interval);

          jQuery("[data-label-text-onetime]").html(
            jQuery("[data-label-text-onetime]").html()
          );
          jQuery("[data-label-text-subsave]").html(
            jQuery("[data-label-text-subsave]").html()
          );
          jQuery(".rc_popup").prependTo(
            ".rc_widget__option.rc_widget__option--subsave .rc_widget__option__selector label"
          );

          jQuery("#product_price").hide();

          jQuery(".rc_widget__option__plans__dropdown").after(
            jQuery("#free_gift")
          );
          jQuery("#free_gift").removeClass("d-none");

          jQuery("#product_price").after(
            jQuery("[data-widget-container-wrapper]")
          );
          // jQuery(".rc_container_wrapper").after(jQuery("#product_buy_box afterpay-placement"));

          jQuery("input.rc_widget__option__input").change(function () {
            if (jQuery(this).val() == "subsave") {
              jQuery("#product_buy_box afterpay-placement").hide();
            } else {
              jQuery("#product_buy_box afterpay-placement").show();
            }
          });

          clearInterval(rebuildRecharge);
        }
      }, 100); // check every 100ms
      // [CART-MIG]
      // jQuery('form[action="/cart/add"]').submit(function (evt) {
      //   evt.preventDefault();

      //   if (
      //     jQuery(".variant-list").length > 0 &&
      //     jQuery(".variant-list button.active").data("variant-id") == undefined
      //   ) {
      //     jQuery(".variant-select h6").css("color", "red");
      //     jQuery("html, body").animate(
      //       { scrollTop: jQuery(".variant-select").offset().top - 450 },
      //       100
      //     );
      //     return false;
      //   }

      //   var form_ele = jQuery(this);
      //   var selected_group = jQuery(this).find(
      //     ".rc_widget__option__input:checked"
      //   );
      //   Shopify.addItemFromForm(form_ele.attr("id"), function () {
      //     if (parseInt(jQuery(window).width()) < 768) {
      //       window.location.href = "/cart";
      //     } else {
      //       MiniCart.notifyUser(true);
      //     }
      //   });
      // });
    };

    ProductPage.init = function () {
      // Get Product JSON data
      ProductPage.product = JSON.parse(
        document.getElementById("ProductJson").innerHTML
      );
      ProductPage.option_count = ProductPage.product.options.length;
      ProductPage.current_variant = getCurrentVariant(
        jQuery("[variant-select]").val()
      );

      if (parseInt(jQuery(window).width()) < 768) {
        // jQuery("#product_title_box").prependTo(
        //   ".product-header > div > div.row > div:first-of-type"
        // );
        // jQuery("#product_title_box").addClass("content");
        // jQuery("#product_buy_actions").addClass("floating-buy-bar");
        jQuery("#product_buy_actions .find-near-you").appendTo(
          jQuery("#product_buy_actions")
        );
        //jQuery('.floating-buy-bar').show();
        window.addEventListener("scroll", showBuyBar);
      } else {
        window.addEventListener("scroll", showBuyBar);
      }

      jQuery(window).on("load", function () {
        jQuery(".twentytwenty-container").each(function (index) {
          jQuery(this).twentytwenty({
            before_label: jQuery(this).find("img.before").data("label"),
            after_label: jQuery(this).find("img.after").data("label"),
          });
        });
      });

      initMip();
      changeVariant();
      bindUIActions();
    };
  })((window.ProductPage = window.ProductPage || {}), jQuery);

//[CART-MIG]
// function (MiniCart, $, undefined) {

//   MiniCart.product = false;
//   MiniCart.cart = false;
//   MiniCart.current_variant = false;
//   MiniCart.current_variant_id = false;
//   MiniCart.ignore_promo_ids = "0";

//   var loadAfterpay = function () {
//     var script = '//static-us.afterpay.com/javascript/present-afterpay.js';
//     var is_loaded = $('script').filter(function () { return ($(this).attr('src') == script); }).length;
//     if(!is_loaded && jQuery('.afterpay-text1').length == 0) {
//       Shopify.getCart(function(cart) {
//         const cartItems = cart.items;
//         const isGiftCard = (item) => item.product_type === "Gift Card";
//         const hasGiftCardItem = cartItems.some(isGiftCard);

//         const apConfig = {
//           priceSelector: '.custom-afterpay-place',
//           amount: cart.total_price,
//           locale: 'en_US',
//           currency: 'USD',
//           giftCard: hasGiftCardItem,
//           minMaxThreshold: {
//             min: 3500,
//             max: 100000,
//           }
//         };

//         jQuery.ajax({
//           url: script,
//           dataType: 'script',
//           success: function() { new presentAfterpay(apConfig).init() },
//           async: true
//         });

//       });
//     } // if(!is_loaded || jQuery('.afterpay-text1').length == 0)
//     return;
//   };

//   var getCurrentVariant = function ( variantId ) {
//     var variants = MiniCart.product.variants;
// 	// map variants and return the selected one

//     var found = jQuery.map(variants, function(variant) {
//       if(variant.id == variantId) {
//         return variant; // return matching variant object
//       }
//     });

//     return found[0]; // returns single array so pull out first element object
//   };

//   var buildRecommendations = function () {

//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;

//       observer.unobserve(productRecommendationsSection);

//       const url = productRecommendationsSection.dataset.url;

//       fetch(url)
//       .then(response => response.text())
//       .then(text => {
//         const html = document.createElement('div');
//         html.innerHTML = text;
//         const recommendations = html.querySelector('.product-recommendations');
//         if (recommendations && recommendations.innerHTML.trim().length) {
//           productRecommendationsSection.innerHTML = recommendations.innerHTML;
//         }

//         MiniCart.init();
//         productRecommendationsSection.querySelectorAll('.cart-item button[data-bs-toggle]').forEach(item => {
//           item.addEventListener('click', event => {
//             event.preventDefault();
//           })
//         });

//       })
//       .catch(e => {
//         console.error(e);
//       });

//     };

//     const productRecommendationsSection = document.querySelector('.product-recommendations');
//     const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
//     observer.observe(productRecommendationsSection);
//   };

//   MiniCart.bindCartActions = function () {
//       console.log("MiniCart.bindCartActions")
//     let product_id = undefined;
//     let variant_id = undefined;
//     let card = undefined;

//     /* Click Add Discount code */
//     const $elDiscountBox = jQuery('#sideCart #addDiscountCode');
//     $elDiscountBox.off("click");
//     $elDiscountBox.on('click', function (evt) {
//       var discount_code = jQuery('input[name="discount"]').val();
//       if( discount_code.length > 0 ) {
//         Shopify.createCookie("discount_code",discount_code, function() {
//           Shopify.runPromotions();
//            Shopify.runPromo();
//         });
//       } else {
//        alert("You must enter a valid discount code");
//       }
//     });

//     const $elsCartMenuItem = jQuery('.cart-mini .dropdown-menu a');
//     $elsCartMenuItem.off("off")
//     $elsCartMenuItem.on('click', function() {
//       location.href = jQuery(this).attr('href');
//     });

//     const $elMinicartClose = jQuery('#MiniCartClose');
//     $elMinicartClose.off("click")
//     $elMinicartClose.on("click", function() {
//       jQuery(this).parents('.dropdown').find('.dropdown-toggle').dropdown('toggle');
// 	  });

//     /* Click Add-to-Cart on item */
//     const $elsRemoveBtn = jQuery('#sideCart [remove-from-cart]');
//     $elsRemoveBtn.off("click");
//     $elsRemoveBtn.on('click', function (evt) {
//       // if variant ID passed, use that
//       evt.preventDefault();
//       const variant_id = jQuery(this).data('variant-id');
//       const item_key = jQuery(this).data('item-key');

//       Shopify.removeItem(variant_id, () => {
//         Shopify.runPromo()
//       }, item_key);
//     });

//     const $elsRemoveBtnCartPage = jQuery('.section-cart [remove-from-cart]');
//     $elsRemoveBtnCartPage.off("click");
//     $elsRemoveBtnCartPage.on('click', function (evt) {

//       // if variant ID passed, use that
//       evt.preventDefault();
//       const variant_id = jQuery(this).data('variant-id');
//       const item_key = jQuery(this).data('item-key');

//       Shopify.removeItem(variant_id, () => {
//         Shopify.runPromo()
//       }, item_key);
//     });

//     const $elsQtySelect = jQuery('#sideCart .order-list [quantity-select]');
//     $elsQtySelect.inputSpinner();
//     $elsQtySelect.off("change")
//     $elsQtySelect.on("change", function (event) {
//       var variant_id = jQuery(this).closest('[quantity-select]').data('variant-id');
//       var item_key = jQuery(this).closest('[quantity-select]').data('item-key');
//       var qty = jQuery(this).val();
//       console.log({ item_key })

//       Shopify.changeItem(variant_id, qty, () => {
//         Shopify.runPromo()
//       }, item_key);
//     });
//   };

//   MiniCart.notifyUser = function(show=true) {

//     var sideCart = jQuery('#sideCart');
//     var sideCartOverlay = jQuery('div.mainNavOverlay.cart');

//     if( parseInt(jQuery(window).width()) > 768) {
//       if(show && sideCart.is(":visible") == false) {
//         if( sideCartOverlay.length > 0 ) {
//           sideCartOverlay.fadeIn(500);
//         } else {
//           jQuery('body').prepend('<div class="mainNavOverlay cart"></div>');
//            var sideCartOverlay = jQuery('div.mainNavOverlay.cart');
//         }
//         sideCartOverlay.on('click', function (evt) { MiniCart.notifyUser(false); });
//         sideCart.fadeIn(500, function() { jQuery(this).animate({ scrollTop: 0 }, 500); });
//         MiniCart.bindCartActions();
//         loadAfterpay();
//         
//           buildRecommendations();
//         
//       } else if(show==false) {
//         sideCartOverlay.fadeOut(500);
//         sideCart.fadeOut(500);
//       } // if(show)
//     } else {

//       var itemAddedToast = document.getElementById('itemAddedToast');
//       var myToast = bootstrap.Toast.getInstance(itemAddedToast);
//       myToast.show();
//     }

//   };

//   MiniCart.bindUIActions = function () {
//     let product_id = undefined;
//     let variant_id = undefined;
//     let card = undefined;
//     let quantity_to_add = 1;

//     /* Click Add-to-Cart on item */
//     const $elsAddToCart = jQuery('[add-to-cart]');
//     $elsAddToCart.off("click")
//     $elsAddToCart.on('click', function (evt) {
//       // if variant ID passed, use that
//       evt.preventDefault();

//       product_id = jQuery(this).data('product-id');
//       variant_id = jQuery(this).data('variant-id');
//       item_key = jQuery(this).data('item-key');
//       card = jQuery('#product-'+product_id);

//       /* item is already in cart */
//       if( card && jQuery(this).hasClass('active') ) {
//         Shopify.removeItem(variant_id, null, item_key);
//       /* item is NOT in cart */
//       } else {
//         Shopify.addItem( variant_id, quantity_to_add, function(item) {
//           if( window.location.pathname == '/cart' ) {
//            window.location.href = window.location.pathname;
//           } else {
//             MiniCart.notifyUser(true);
//           }
//     	});
//       } // if( jQuery(this).hasClass('active') )
//     });

//     var productModals = [].slice.call(document.querySelectorAll('.modal.product'));
//     var productModal = productModals.map(function (productModalEl) {
//       productModalEl.addEventListener('shown.bs.modal', function (event) {
//         var product_id = jQuery(event.target).data('product-id');
//         var variant_id = jQuery(event.target).data('variant-id');
//         var modal = bootstrap.Modal.getInstance(event.target);

//         if( product_id == 8093827784) {
//           jQuery(event.target).find('button.btn-primary').html('Select your Retinol Strength');
//           jQuery(event.target).find('button.btn-primary').attr("disabled", true);
//         }

//         jQuery('[variant-list] button').click(function() {
//           jQuery('[variant-list] .btn').removeClass('active');
//           jQuery(this).addClass('active');
//           jQuery(event.target).find('[variant-select]').val( jQuery(this).data('variant-id') );
//           jQuery(event.target).find('button.btn-primary').html("Add to Bag");
//           jQuery(event.target).find('button.btn-primary').attr("disabled", false);
//           jQuery(event.target).find('[product-price]').html( jQuery(this).data('price') );
//           jQuery(event.target).find('[add-to-cart]').data('variant-id', jQuery(this).data('variant-id') );
//         });

//         jQuery(event.target).find('[add-to-cart]').click(function(evt) {
//           modal.hide();
//         });
//       });

//       productModalEl.addEventListener('hidden.bs.modal', function (event) {
//         var modal = bootstrap.Modal.getInstance(event.target);
//         if( jQuery('.modal-backdrop') ) {
//           jQuery('.modal-backdrop').remove();
//           jQuery('.modal-backdrop').hide();
//           jQuery('body').removeClass('modal-open');
//           jQuery('body').attr('style','');
//           modal.modal('hide');
//         }
//       });
//     });
//   };

//   MiniCart.init = function () {

//     jQuery(".cart-mini .nav-link").on('click', function(evt) {
//       evt.preventDefault();
//       if( parseInt(jQuery(window).width()) > 768 && Shopify.request_path != '/cart') {
//         Shopify.runPromotions();
//         Shopify.runPromo();
//         MiniCart.notifyUser(true);
//       } else {
//         window.location.href = this.href;
//       }
//     });

//     if( parseInt(jQuery(window).width()) > 768 ) {
//       jQuery('#sideCart .cart-close').on('click', function (evt) { evt.preventDefault(); MiniCart.notifyUser(false); });
//     } else {
//       jQuery('#sideCart').remove();
//     } // if( parseInt(jQuery(window).width()) > 768 )

//     MiniCart.bindUIActions();
//   };

// }(window.MiniCart = window.MiniCart || {}, jQuery),
// function (Cart, $, undefined) {

//   var bindUIActions = function () {

//     jQuery(".section-cart [quantity-select]").inputSpinner();
//     if( jQuery('.cart-product-recommendations').length > 0 && parseInt(jQuery(window).width()) < 768 ) {
//       jQuery('#designatorContainer').insertBefore('.cart-product-recommendations');
//     }

//     if( jQuery('.discount-container').length > 0 && parseInt(jQuery(window).width()) < 768 ) {
//       jQuery('.discount-container').insertAfter('.order-list');
//     }

//     /* Click Add Discount code */
//     const $elDiscountBox = jQuery('.section-cart #addDiscountCode');
//     $elDiscountBox.off("click");
//     $elDiscountBox.on('click', function (evt) {
//       var discount_code = jQuery('input[name="discount"]').val();
//       if( discount_code.length > 0 ) {
//         Shopify.createCookie("discount_code",discount_code, function() {
//           Shopify.runPromotions();
//            Shopify.runPromo();
//         });
//       } else {
//        alert("You must enter a valid discount code");
//       }
//     });

//     const $elsQtySelect = jQuery('.section-cart [quantity-select]');
//     $elsQtySelect.inputSpinner();
//     $elsQtySelect.off("change")
//     $elsQtySelect.on("change", function (event) {
//       var variant_id = jQuery(this).closest('[quantity-select]').data('variant-id');
//       var item_key = jQuery(this).closest('[quantity-select]').data('item-key');
//       var qty = jQuery(this).val();

//       Shopify.changeItem(variant_id, qty, () => {
//         Shopify.runPromo()
//       }, item_key);
//     });

//     /* Click Add-to-Cart on item */
//     const $elsRemoveBtn = jQuery('.section-cart [remove-from-cart]');
//     $elsRemoveBtn.off("click");
//     $elsRemoveBtn.on('click', function (evt) {
//       console.log("remove 1")
//       // if variant ID passed, use that
//       evt.preventDefault();
//       const variant_id = jQuery(this).data('variant-id');
//       const item_key = jQuery(this).data('item-key');

//       Shopify.removeItem(variant_id, () => {
//         Shopify.runPromo()
//       }, item_key);
//     });
//   };

//   Cart.init = function () {
//     Shopify.runPromotions();
//     Shopify.runPromo();
//     bindUIActions();
//   };

// }(window.Cart = window.Cart || {}, jQuery);

// function toggleSideCart() {
//   const sideCart = document.getElementById("sideCart");
//   const sideCartOverlay = document.querySelector("[data-sidecart-overlay]");
//   const visiblity = sideCart.style.display === "block" ? "none" : "block";
//   sideCart.style.display = visiblity;
//   sideCartOverlay.style.display = visiblity;
// }

// function openSideCart() {
//   const sideCart = document.getElementById("sideCart");
//   const sideCartOverlay = document.querySelector("[data-sidecart-overlay]");
//   const visiblity = "block";
//   sideCart.style.display = visiblity;
//   sideCartOverlay.style.display = visiblity;
// }

// window.Minicart = {
//   toggleSideCart,
//   openSideCart,
// };

// function togglerMethod(event) {
//   const element = event.target.closest("[data-sidecart-toggler]");
//   if (element) {
//     event.preventDefault();
//     toggleSideCart();
//   }
// }
// document.addEventListener(
//   "click",
//   (event) => {
//     if (event) {
//       togglerMethod(event);
//     }
//   },
//   false
// );

// document.addEventListener("liquid-ajax-cart:init", () => {
//   liquidAjaxCart.conf("updateOnWindowFocus", false);
// });
// document.addEventListener("liquid-ajax-cart:request-end", (event) => {
//   const { requestState } = event.detail;

//   if (requestState.requestType === "add" && requestState.responseData?.ok) {
//     console.log("requestState", window.innerWidth);
//     if (window.innerWidth > 768) {
//       window.Minicart?.openSideCart();
//     } else {
//       var itemAddedToast = document.getElementById("itemAddedToast");
//       var myToast = bootstrap.Toast.getInstance(itemAddedToast);
//       myToast.show();
//     }
//   }
// });

// function openSideCart(show = true) {
//   var sideCart = jQuery("#sideCart");
//   var sideCartOverlay = jQuery("div.mainNavOverlay.cart");

//   if (parseInt(jQuery(window).width()) > 768) {
//     if (show && sideCart.is(":visible") == false) {
//       if (sideCartOverlay.length > 0) {
//         sideCartOverlay.fadeIn(500);
//       } else {
//         jQuery("body").prepend('<div class="mainNavOverlay cart"></div>');
//         var sideCartOverlay = jQuery("div.mainNavOverlay.cart");
//       }
//       sideCartOverlay.on("click", function (evt) {
//         MiniCart.notifyUser(false);
//       });
//       sideCart.fadeIn(500, function () {
//         jQuery(this).animate({ scrollTop: 0 }, 500);
//       });
//       MiniCart.bindCartActions();
//       loadAfterpay();
//       // 
//       //   buildRecommendations();
//       // 
//     } else if (show == false) {
//       sideCartOverlay.fadeOut(500);
//       sideCart.fadeOut(500);
//     } // if(show)
//   } else {
//     var itemAddedToast = document.getElementById("itemAddedToast");
//     var myToast = bootstrap.Toast.getInstance(itemAddedToast);
//     myToast.show();
//   }
// }

  function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  observer.disconnect();
                  resolve(document.querySelector(selector));
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }

  var productModals;
  waitForElm(".modal.product").then((el) => {
    productModals = [].slice.call(document.querySelectorAll(".modal.product"));
    console.log(productModals)

    var productModal = productModals.map(function (productModalEl) {
  productModalEl.addEventListener("shown.bs.modal", function (event) {
    var product_id = jQuery(event.target).data("product-id");
    var variant_id = jQuery(event.target).data("variant-id");
    var modal = bootstrap.Modal.getInstance(event.target);

    if (product_id == 8093827784) {
      jQuery(event.target)
        .find("button.btn-primary")
        .html("Select your Retinol Strength");
      jQuery(event.target).find("button.btn-primary").attr("disabled", true);
    }

    jQuery("[variant-list] button").click(function () {
      const newVariantId = jQuery(this).attr("data-variant-id");
      jQuery("[variant-list] .btn").removeClass("active");
      jQuery(this).addClass("active");

      jQuery(event.target).find("[variant-select]").val(newVariantId);

      jQuery(event.target)
        .find("button.btn-primary")
        .html("Add to Bag");

      jQuery(event.target).find("button.btn-primary").attr("disabled", false);

      jQuery(event.target)
        .find("[product-price]")
        .html(jQuery(this).data("price"));

      jQuery(event.target)
        .find("[data-variant-id]")
        .data("variant-id", newVariantId);
    });

    jQuery(event.target)
      .find("button[type='submit']")
      .click(function (evt) {
        modal.hide();
      });
  });

    productModalEl.addEventListener("hidden.bs.modal", function (event) {
    var modal = bootstrap.Modal.getInstance(event.target);

    if (jQuery(".modal-backdrop")) {
      jQuery(".modal-backdrop").remove();
      jQuery(".modal-backdrop").hide();
      jQuery("body").removeClass("modal-open");
      jQuery("body").attr("style", "");
      if (modal) {
        console.log(modal);
        // modal.modal("hide");
      }
    }
  });
  })
});

/* --------------- */
/* Featured quotes */
class FeaturedQuotesSection {
  quoteElements = [];
  activeQuoteElement = null;
  intervalSpeed = 5000;

  constructor(fqElement) {
    this.quoteElements = [...fqElement.querySelectorAll(".featured-quote")];
    this.activeQuoteElement = fqElement.querySelector(
      ".featured-quotes__active-quote"
    );

    if (!this.activeQuoteElement.innerText)
      this._setActiveQuote(this.quoteElements[0]);

    this.quoteElements.forEach((quoteElement) => {
      quoteElement.addEventListener("click", () => {
        this._setActiveQuote(quoteElement);
        this._pauseAutoplay();
      });
    });

    this._autoPlay(this.quoteElements, this.intervalSpeed);
  }

  _autoPlay(quoteElements, intervalSpeed) {
    const totalElements = quoteElements.length;
    if (totalElements < 1) return;
    let currentElement = 0;
    let interval = setInterval(() => {
      if (this.isPaused) clearInterval(interval);
      this._setActiveQuote(quoteElements[currentElement]);
      currentElement = (currentElement + 1) % totalElements;
    }, intervalSpeed);
  }

  _pauseAutoplay() {
    this.isPaused = true;
  }

  _setActiveQuote(quoteElement) {
    const quoteText = quoteElement.dataset.quote;

    this.quoteElements.forEach((qe) => (qe.dataset.isActive = "false"));
    quoteElement.dataset.isActive = "true";

    if (this.activeQuoteElement) this.activeQuoteElement.innerText = quoteText;
  }
}
const featuredQuotes = [...document.querySelectorAll(".featured-quotes")];
if (featuredQuotes.length) {
  featuredQuotes.forEach((fq) => new FeaturedQuotesSection(fq));
}

const featuredCategoriesSliders = jQuery(
  '.featured-categories__items[data-slider-is-enabled="true"]'
);
const featuredCategoriesMobileSliders = jQuery(
  '.featured-categories__items[data-slider-is-enabled="false"]'
);
if (featuredCategoriesSliders.length) {
  featuredCategoriesSliders.each(function () {
    jQuery(this).slick({
      arrows: true,
      inifinite: true,
      slidesToShow: 3,
      touchMove: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "10%",
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  });
}
if (featuredCategoriesMobileSliders.length) {
  featuredCategoriesMobileSliders.each(function () {
    jQuery(this).slick({
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      touchMove: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: featuredCategoriesMobileSliders.attr("data-disable-center-mode") ? false : true,
            variableWidth: !!featuredCategoriesMobileSliders.attr("data-center-variable-width"),
            centerPadding: featuredCategoriesMobileSliders.attr("data-center-padding") || "10%",
            dots: true,
            touchMove: true,
            inifinite: true,
          },
        },
      ],
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const announcementsSliders = jQuery(".announcements-slider__list");
  if (announcementsSliders.length) {
    announcementsSliders.each(function () {
      jQuery(this).slick({
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 1000,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false
          }
        }
      ]
      });
    });
  }
  const targetNode = document.getElementById('mainNavbarCollapse');
  if (targetNode) {
      const config = {
          attributes: true,
          attributeFilter: ['class', 'style']
      };

      const callback = function(mutationsList, observer) {
          for (const mutation of mutationsList) {
              if (mutation.type === 'attributes') {
                announcementsSliders.each(function () {
                  jQuery(this).slick('unslick').slick({
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 10000,
                    speed: 1000,
                    responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: false
                      }
                    }
                  ]
                  });
                });
              }
          }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
  }
})

function toggleClass(elementSelectors, className) {
  document
    .querySelectorAll(elementSelectors)
    .forEach((el) => el.classList.toggle(className));
}

const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
const headerBreakpoint = 1200;
dropdownToggles.forEach((dt) => {
  dt.addEventListener("click", (e) => {
    const href = dt.href;
    const hasAlwaysOpenedDropdown = dt.dataset.alwaysOpenedDropdown === "true";
    if ((window.innerWidth > 1200 && href) || hasAlwaysOpenedDropdown) {
      window.location = href;
    }
  });
});

function toggleClass(elementSelectors, className) {
  document
    .querySelectorAll(elementSelectors)
    .forEach((el) => el.classList.toggle(className));
}

if (
  $("section.proven-effects .proven-effects__container").length &&
  window.innerWidth <= 900
) {
  $("section.proven-effects .proven-effects__container").slick({
    arrows: false,
    dots: true,
  });
}

if (
  $("section.key-ingredients .key-ingredients__container").length &&
  window.innerWidth <= 900
) {
  $("section.key-ingredients .key-ingredients__container").slick({
    arrows: false,
    dots: true,
    autoplay: true
  });
}


if ($(".slick-regimen_container").length) {
  $(".slick-regimen_container").slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
}

function smoothScroll(event) {
  const element = event.target.closest("[data-smoothscroll]");

  if (element) {
    event.preventDefault();
    const header = document.querySelectorAll(".global-header");
    const productNav = document.querySelector(
      ".floating-buy-bar.fixed-top .top-navigation"
    );
    const productNavHeight = productNav.offsetHeight;
    let stickyElemsHeight = 0;
    if (header && header.offsetHeight) {
      stickyElemsHeight += header.offsetHeight;
    }
    if (productNav && productNav.offsetHeight) {
      stickyElemsHeight += productNav.offsetHeight;
    }
    const section = document.querySelector(element.getAttribute("href"));
    const offset = element.dataset.smoothscroll
      ? parseInt(element.dataset.smoothscroll)
      : 5;
    const bodyOffset = document.body.getBoundingClientRect().top;
    window.scrollTo({
      top:
        section.getBoundingClientRect().top -
        bodyOffset +
        offset -
        productNavHeight,
      behavior: "smooth",
    });
  }
}

document.addEventListener(
  "click",
  (event) => {
    if (event) {
      smoothScroll(event);
    }
  },
  false
);

function stickySections() {
  const topNav = document.querySelector("[data-announcement-bar]").parentElement;
  const header = document.querySelector("[data-main-header]").parentElement;
  let sectionScroll = topNav.offsetHeight;

  if (window.scrollY >= sectionScroll) {
    header.classList.add("stickyHeader");
  } else {
    header.classList.remove("stickyHeader");
  }
}

function stickySectionsNav() {
  const header = document.querySelector("[data-main-header]").parentElement;
  const stickyHeaderHeight = header.offsetHeight;
  const stickyHeaderHeight2 =
    document.querySelector(".global-header").offsetHeight;
  const nav = document.querySelector(
    ".floating-buy-bar.fixed-top .top-navigation"
  );
  const sections = document.querySelectorAll("section");
  const navLi = nav.querySelectorAll("a");
  const topNav = document.querySelector("[data-announcement-bar]").parentElement;
  let sectionScroll = topNav.offsetHeight;
  let current = "";

  if (window.scrollY >= sectionScroll) {
    document
      .querySelector(".floating-buy-bar.fixed-top .buy-actions")
      .setAttribute("style", `margin-top:${stickyHeaderHeight}px;`);
  } else {
    document
      .querySelector(".floating-buy-bar.fixed-top .buy-actions")
      .setAttribute(
        "style",
        `margin-top:${stickyHeaderHeight2 - window.scrollY}px;`
      );
  }

  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (window.scrollY >= sectionTop - stickyHeaderHeight) {
      current = section.getAttribute("id");
    }
  });
  navLi.forEach((item) => {
    item.classList.remove("active");
    const href = item.getAttribute("href");

    if (href === "#" + current) {
      item.classList.add("active");
    }
  });
}

window.addEventListener("scroll", function () {
  if ($(".floating-buy-bar.fixed-top .top-navigation").length) {
    stickySectionsNav();
  }
  stickySections();
});

if (
  $(".floating-buy-bar.fixed-top .top-navigation").length &&
  window.innerWidth <= 900
) {
  const stickyHeaderHeight =
    document.querySelector(".global-header").offsetHeight;
  document
    .querySelector(".floating-buy-bar.fixed-top .buy-actions")
    .setAttribute("style", `margin-top:${stickyHeaderHeight}px;`);
  const productNav = document.querySelector(
    ".floating-buy-bar.fixed-top .top-navigation"
  );
  const productNavHeight = productNav.offsetHeight;
  document
    .querySelector("main")
    .setAttribute("style", `padding-top:${productNavHeight}px;`);
}

if ($("section.key-ingredients .key-ingredients__container").length) {
  $(".key-ingredients .button").click(function () {
    $(".key-ingredients__popup-shadow, .key-ingredients__popup").show();
  });

  $(".key-ingredients__popup svg, .key-ingredients__popup-shadow").click(
    function () {
      $(".key-ingredients__popup-shadow, .key-ingredients__popup").hide();
    }
  );
}

// let lstrkCookie = document.cookie;

// if (lstrkCookie.indexOf('lstrk_popup') <= 1){

//     $(`<div class="lstrk_popup-button__container"><span class="lstrk_popup-button__open">EXCLUSIVE DISCOUNT</span><svg class="lstrk_popup-button__close" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
//     <path d="M11 1.5L1 11.5" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"></path>
//     <path d="M1 1.5L11 11.5" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"></path>
//     </svg></div>
//     `).prependTo('body');

//     $('.lstrk_popup-button__close').click(function(){

//         $('.lstrk_popup-button__container').hide();
//         document.cookie = "lstrk_popup=true";

//     });

//     $('.lstrk_popup-button__open').click(function(){

//       _ltk.Popup.openManualByName('AVEX POPUP');

//     });

// }

// $('[href="#lstrk"]').click(function(){

//   _ltk.Popup.openManualByName('AVEX POPUP');

// });

function buildRecharge() {
  let rechargeId = $(".activeSub").attr("data-product-id");
  $(".activeSub").removeClass("activeSub");
  rechargeId = parseInt(rechargeId);
  const config = {
    productId: rechargeId,
    injectionParent: 'form[action*="cart/add"]',
    injectionMethod: "prepend",
  };
  window.ReChargeWidget.createWidget(config);
  var rebuildRecharge = setInterval(function () {
    if (jQuery(".rc_container_wrapper").length > 0) {
      jQuery(".rc_widget__option__label").each(function (index) {
        jQuery(this).find(".rc_widget__price").prependTo(this);
        var discount_elem = jQuery(this).find(".rc_widget__option__discount");
        if (discount_elem.html() != undefined) {
          discount_elem.html(
            " (Free Gifts + " + discount_elem.html() + " OFF + Free Shipping)"
          );
        }
      });

      var default_interval = jQuery("[data-recharge-interval]").data(
        "recharge-interval"
      );
      jQuery(
        '.rc_widget__option__plans__dropdown option[value="' +
          default_interval +
          '"]'
      ).append(" (recommended)");
      jQuery(".rc_widget__option__plans__dropdown").val(default_interval);

      jQuery("[data-label-text-onetime]").html(
        jQuery("[data-label-text-onetime]").html()
      );
      jQuery("[data-label-text-subsave]").html(
        jQuery("[data-label-text-subsave]").html()
      );
      jQuery(".rc_popup").prependTo(
        ".rc_widget__option.rc_widget__option--subsave .rc_widget__option__selector label"
      );

      jQuery("#product_price").hide();

      jQuery(".rc_widget__option__plans__dropdown").after(jQuery("#free_gift"));
      jQuery("#free_gift").removeClass("d-none");

      jQuery("#product_price").after(jQuery("[data-widget-container-wrapper]"));
      jQuery(".rc_container_wrapper").after(jQuery(".afterpay-paragraph"));

      jQuery("input.rc_widget__option__input").change(function () {
        if (jQuery(this).val() == "subsave") {
          jQuery(".afterpay-paragraph").hide();
        } else {
          jQuery(".afterpay-paragraph").show();
        }
      });

      clearInterval(rebuildRecharge);
    }
  }, 100); // check every 100ms
}
// [CART-MIG]
// var addToCartSubscription = function () {
//   jQuery('form[action="/cart/add"]').submit(function (evt) {
//     evt.preventDefault();

//     // if( jQuery('.variant-list').length > 0 && jQuery('.variant-list button.active').data('variant-id') == undefined ) {
//     //   jQuery('.variant-select h6').css('color','red');
//     //   jQuery('html, body').animate({scrollTop: jQuery('.variant-select').offset().top -450 }, 100);
//     //   return false;
//     // }

//     var form_ele = jQuery(this);
//     var selected_group = jQuery(this).find(".rc_widget__option__input:checked");
//     Shopify.addItemFromForm(form_ele.attr("id"), function () {
//       if (parseInt(jQuery(window).width()) < 768) {
//         window.location.href = "/cart";
//       } else {
//         MiniCart.notifyUser(true);
//       }
//     });
//   });
// };

var initMipSlick = function () {
  var carousel_element = "#mip-carousel div .carousel-hero";
  var carousel_nav_element = "#mip-carousel div .carousel-nav";
  // If carousel content exists
  if (jQuery(carousel_element).length > 0) {
    jQuery(carousel_element).not(".slick-initialized").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      touchMove: true,
      arrows: true,
      fade: true,
      dots: true,
      lazyLoad: "ondemand",
      asNavFor: carousel_nav_element,
      nextArrow:
        '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289L6.34315 0.928932C5.95262 0.538408 5.31946 0.538408 4.92893 0.928932C4.53841 1.31946 4.53841 1.95262 4.92893 2.34315L10.5858 8L4.92893 13.6569C4.53841 14.0474 4.53841 14.6805 4.92893 15.0711C5.31946 15.4616 5.95262 15.4616 6.34315 15.0711L12.7071 8.70711ZM0 9L12 9V7L0 7L0 9Z" fill="#1e1e1e"/></svg></button>',
      prevArrow:
        '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289L6.34315 0.928932C5.95262 0.538408 5.31946 0.538408 4.92893 0.928932C4.53841 1.31946 4.53841 1.95262 4.92893 2.34315L10.5858 8L4.92893 13.6569C4.53841 14.0474 4.53841 14.6805 4.92893 15.0711C5.31946 15.4616 5.95262 15.4616 6.34315 15.0711L12.7071 8.70711ZM0 9L12 9V7L0 7L0 9Z" fill="#1e1e1e"/></svg></button>',
    });

    jQuery(carousel_nav_element).not(".slick-initialized").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      touchMove: true,
      focusOnSelect: true,
      infinite: true,
      arrows: false,
      vertical: true,
      asNavFor: carousel_element,
    });

    jQuery(carousel_nav_element)
      .find(".slick-slide")
      .each(function (index) {
        jQuery(this).css(
          "margin-top",
          (jQuery(carousel_nav_element).height() - jQuery(this).height()) / 2 +
            "px"
        );
      });
  } // end If carousel content exists
};

var initSubscription = function (data, url) {
  $(data).appendTo(".subscription-modal");
  buildRecharge();
  // addToCartSubscription();

  if (parseInt(jQuery(window).width()) < 1050) {
    // jQuery("#product_title_box").prependTo(
    //   ".product-header > div > div.row > div:first-of-type"
    // );
    // jQuery("#product_title_box").addClass("content");
  }
  let productDesc = $(".product_description").html();
  let productDescArray = productDesc.split("<a");
  let newProductDesc =
    productDescArray[0].split(/\s+/).slice(0, 10).join(" ") +
    "... <a" +
    productDescArray[1];

  $(".product_description").html(newProductDesc);

  let selectSubsave = setInterval(function () {
    if ($("[data-radio-subsave]").length) {
      $("[data-radio-subsave]").click();
      $("[data-plans-dropdown]").attr("name", "selling_plan");
      $("[data-plans-dropdown] option:first-child").attr("selected", "true");
      $(".product_description a").attr("href", `${url}`);
      $("div#product_title_box")
        .before(`<svg data-close-subscription xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
          <path d="M18.1852 1.97406L17.0318 0.820679L9.18518 8.6673L1.33831 0.820679L0.185181 1.97406L8.03206 9.82068L0.185181 17.6673L1.33831 18.8207L9.18518 10.9741L17.0318 18.8207L18.1852 17.6673L10.3388 9.82068L18.1852 1.97406Z" fill="#505153"/>
        </svg>`);
      let OGprice = $("[data-price-onetime]").text();
      OGprice = `<span style="text-decoration: line-through; margin-right: 6px; font-weight: 400 !Important;">${OGprice}</span>`;
      $(OGprice).prependTo("[data-price-subsave]");
      // $('.subscription-modal .cta-btn_container').click(function(){$('.subscription-modal > *').remove();});
      $("[data-close-subscription-overlay]").click(function () {
        $(".subscription-modal").hide();
        $(".subscription-modal > *").remove();
        $("body").attr("style", "");
      });
      $("[data-close-subscription]").click(function () {
        $(".subscription-modal").hide();
        $(".subscription-modal > *").remove();
        $("body").attr("style", "");
      });
      $("body").attr("style", "overflow:hidden");
      clearInterval(selectSubsave);
    }
  }, 500);

  $("<div data-close-subscription-overlay></div>").prependTo(
    ".subscription-modal"
  );
  $(".subscription-modal").fadeIn();
  setTimeout(function () {
    initMipSlick();
  }, 333);
};

$("[add-to-cart-subscription]").click(function () {
  $(".subscription-modal").hide();
  $(".subscription-modal > *").remove();
  $("body").attr("style", "");
  let url = $(this).attr("data-product-url");
  $(this).addClass("activeSub");
  fetch(`${url}?section_id=block-product-header-free-shipping`)
    .then((response) => response.text())
    .then(function (data) {
      if (
        !$(
          ".subscription-modal div#shopify-section-block-product-header-free-shipping"
        ).length
      ) {
        initSubscription(data, url);
      }
    });
});

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.resizeImage = function (image, size) {
  try {
    if (size == "original") {
      return image;
    } else {
      var matches = image.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return matches[1] + "_" + size + "." + matches[2];
    }
  } catch (e) {
    return image;
  }
};

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('#insta-feed > h2').then((elm) => {
    elm.textContent = "Follow Us @alastinskincare";
});
$("[data-advanced-slider]").on("init", function(event, slick){
  slick.$slider.find(".slick-slide").removeClass("slick-before-center")
  slick.$slider.find(".slick-center").prev().addClass("slick-before-center")
});

$("[data-advanced-slider]").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  centerMode: true,
  centerPadding: 0,
  responsive: [
    {
      breakpoint: 997,
      settings: {
        slidesToShow: 3
      }
    }
  ]
})

$("[data-advanced-slider]").on("beforeChange", function(event, slick, currentSlide, nextSlide){
  addBeforeCenterClass(slick)
});

$("[data-advanced-slider]").on("afterChange", function(event, slick, direction){
  slick.$slider.find(".slick-slide").removeClass("slick-before-center")
  slick.$slider.find(".slick-center").prev().addClass("slick-before-center")
});

function addBeforeCenterClass(slick) {
  slick.$slider.find(".slick-slide").removeClass("slick-before-center")
  slick.$slider.find(".slick-center").addClass("slick-before-center")
}

function getHeaderHeight() {
  const header = document.querySelector("[data-main-header]").parentElement;

  document.documentElement.style.setProperty(
    "--header-height",
    header.offsetHeight + "px"
  );
}

document.addEventListener('DOMContentLoaded', () => {
    getHeaderHeight();

    document.querySelectorAll('[data-expand-button]').forEach(button => {
      const wrapper = button.closest('.image-grid__description-wrapper');
      const descEl = wrapper.querySelector('[data-desc]');
      const fullText = wrapper.getAttribute('data-full');
      const shortText = fullText.length > 150 ? fullText.slice(0, 150) + '…' : fullText;

      let expanded = false;

      button.addEventListener('click', () => {
        expanded = !expanded;
        descEl.textContent = expanded ? fullText : shortText;
        button.textContent = expanded
          ? button.getAttribute('data-label-hide')
          : button.getAttribute('data-label-expand');
      });
    });
  });